/**
 * NewsListItem
 * @module components/NewsListItem
 */
import { useSiteType } from 'context/siteType.context';
import { Li, Link, Text, Title, Category } from './NewsList.styles';
import clsx from 'clsx';

interface NewsListItemModel {
	title: string;
	category: string;
	date: string;
	url: string;
}

const NewsListItem = ({ category, date, title, url }: NewsListItemModel) => {
	const siteType = useSiteType();
	return (
		<Li>
			<Link href={url}>
				<Text>
					{category && (
						<Category isLindabGroup={siteType === 'LindabGroup'}>
							{category}
						</Category>
					)}
					{date && (
						<span
							className={clsx(
								siteType === 'LindabGroup' && 'text-lgDarkGray font-medium'
							)}
						>
							{date}
						</span>
					)}
				</Text>
				<Title isLindabGroup={siteType === 'LindabGroup'}>{title}</Title>
			</Link>
		</Li>
	);
};

export default NewsListItem;
